type Loc = {
  address: string
  city: string
  state: string
  postalCode: string
}

export function getMapUrl(location: Loc) {
  const { address, city, state, postalCode } = location
  const baseUrl = 'https://www.google.com/maps'
  const satelliteView = 'data=!3m1!1e3'
  let query = ''

  if (address) query += address + ','
  if (city) query += city + ','
  if (state) query += state + ','
  if (postalCode) query += postalCode
  if (!query) return `${baseUrl}/@/${satelliteView}`

  const encodedQuery = encodeURIComponent(query)
  return `${baseUrl}/place/${encodedQuery}/@/${satelliteView}`
}
